import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'robustDate'
})
export class RobustDatePipe implements PipeTransform {
  // Value ist ein Object mit den etrs89 x,y koordinaten
  transform(value: unknown): any {
    const datePipe = new DatePipe('de-DE');
    try {
      value = datePipe.transform(value as string, 'dd.MM.yyyy');
      return value;
    } catch (exp) {
      return value;
    }
  }
}
